var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('portal',{attrs:{"to":"modal","order":_vm.order}},[_c('transition',{attrs:{"appear":"","name":"modal-backdrop","mode":"out-in"},on:{"enter":_vm.onEnter,"leave":_vm.onLeave}},[_c('div',{staticClass:"modal",attrs:{"to":"modal"}},[_c('div',{staticClass:"modal__content",class:_vm.classNames},[_vm._t("default")],2)])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }